import { useState, useEffect, useContext } from 'react';
import {ErrorContext} from '../Contexts/ErrorContext'
import VehicleService from '../Services/VehicleService';
import {extractErrorMessage} from '../Services/RequestService';
import {removeFromCollection, replaceInCollection} from './utils';
import { isNull } from 'lodash';

export const useVehicles = (shouldShowActiveVehicles = null) => {
    const [vehicles, setVehicles] = useState([]);
    const token = localStorage.getItem("token");
    const {setError, success} = useContext(ErrorContext);

    const loadAll = async () => {
        try {
            const resp = await VehicleService.allVehicles(token);
            const correctVehicles = resp.data.filter(({isActive}) => isNull(shouldShowActiveVehicles) ? true : isActive === shouldShowActiveVehicles)
            setVehicles(correctVehicles);
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const addVehicle = async (vehicle) => {
        try {
            let resp = await VehicleService.addVehicle(vehicle, token);
            setVehicles([...vehicles, {...vehicle, id: resp.data.id}]);
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const updateVehicle = async (vehicle) => {
        try {
            await VehicleService.updateVehicle(vehicle, token);
            setVehicles(replaceInCollection(vehicle, vehicles));
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const deleteVehicle = async (vehicle) => {
        try {
            await VehicleService.deleteVehicle(vehicle.id, token);
            setVehicles(removeFromCollection(vehicle, vehicles));
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const deregisterVehicle = async (vehicleId) => {
        try {
            await VehicleService.deregisterVehicle(vehicleId, token);
            loadAll()
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const reregisterVehicle = async (deregisterId) => {
        try {
            await VehicleService.reregisterVehicle(deregisterId, token);
            loadAll()
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const editDeregister = async (newData, id) => {
        try {
            await VehicleService.editDeregister(newData, id, token);
            loadAll()
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    useEffect(() => {
        loadAll()
    }, []);

    return [vehicles, addVehicle, updateVehicle, deleteVehicle, deregisterVehicle, reregisterVehicle, editDeregister];
}


// WEBPACK FOOTER //
// ./src/Hooks/useVehicles.js